var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.85 26.88"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 26.88V13.44L11.93 0l11.93 13.06v13.82h-9.24l.16-8.74H9.41l-.17 8.74H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }